<template>
  <div>
    <van-nav-bar @click-left="clickBack" title="进出详情" left-arrow>
    </van-nav-bar>
    <div class="card">
      <div class="cell">
        <span class="headline">家长姓名</span>
        <span>{{ query.parentName }}</span>
      </div>
      <div class="title border-b">
        孩子信息
      </div>

      <div
        class="panel flex flex-vc border-b"
        v-for="item in query.childDTOS"
        :key="item.id"
      >
        <img :src="item.avatar" alt="" @click="previewImg(item.avatar)" />
        <div class="info">
          <div class="name">{{ item.name }}</div>
          <div class="phone">{{ item.className }}</div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="title border-b">
        进出信息
      </div>
      <!-- <div class="panel flex flex-vc border-b">
        <img
          :src="data.pickUpPhoto"
          alt=""
          @click="previewImg(data.pickUpPhoto)"
        />
        <div class="info">
          <div class="name">{{ query.pickUpPerson }}</div>
          <div class="phone">{{ query.pickUpPhone }}</div>
        </div>
      </div> -->

      <div class="cell">
        <span class="headline">审批状态</span>
        <van-tag plain type="success" size="medium" v-if="query.leaveState == 1"
          >已同意</van-tag
        >
        <van-tag plain type="primary" size="medium" v-if="query.leaveState == 0"
          >待审批</van-tag
        >
        <van-tag plain type="danger" size="medium" v-if="query.leaveState == 2"
          >已拒绝</van-tag
        >
      </div>
      <div class="cell">
        <span class="headline">开始时间</span>
        <span>{{ query.leaveTime }} {{ query.leaveBeginTime }}</span>
      </div>
      <div class="cell">
        <span class="headline">结束时间</span>
        <span>{{ query.leaveTime }} {{ query.leaveEndTime }}</span>
      </div>
      <div class="cell">
        <span class="headline">原因</span>
        <span style="flex: 1;">{{ query.remark }}</span>
      </div>
    </div>
    <div class="btn-group">
      <van-row :gutter="20" class="btn-wrap" v-if="type != 'au'">
        <van-col :span="24">
          <van-button round type="info" block @click="clickBack"
            >返回</van-button
          >
        </van-col>
      </van-row>
      <van-row :gutter="20" class="btn-wrap" v-if="type == 'au'">
        <template v-if="query.leaveState == 0">
          <van-col :span="12">
            <van-button round type="warning" block @click="handleAudit(2)"
              >拒绝</van-button
            >
          </van-col>
          <van-col :span="12">
            <van-button round type="info" block @click="handleAudit(1)"
              >通过</van-button
            >
          </van-col>
        </template>
        <template v-else>
          <van-col :span="24">
            <van-button round type="info" block @click="clickBack"
              >返回</van-button
            >
          </van-col>
        </template>
      </van-row>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  data() {
    return {
      query: {},
    }
  },
  mounted() {
    this.query = this.$route.query
  },
  computed: {
    // query() {
    //   return this.$route.query
    // },
    type() {
      return this.$route.query.type
    },
  },
  methods: {
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      })
    },
    clickBack() {
      this.$router.go(-1)
    },

    handleAudit(leaveState) {
      this.$dialog
        .confirm({
          title: '温馨提示',
          message: leaveState == 1 ? '是否通过？' : '是否拒绝？',
        })
        .then(() => {
          // on confirm
          this.accessAudit(leaveState)
        })
        .catch(() => {
          // on cancel
          this.accessAudit(leaveState)
        })
    },
    async accessAudit(state) {
      const { code } = await this.$https.accessAudit({
        teacherId: this.$store.state.userId,
        leaveState: state,
        id: this.query.id,
      })
      if (code !== 200) {
        this.$toast('审批失败')
        return
      }
      if (state == 1) {
        this.query.leaveState = 1
      } else {
        this.query.leaveState = 2
      }
      this.$toast('成功')
    },
  },
}
</script>

<style lang="scss" scoped>
.border-b {
  border-bottom: 1px solid #f4f4f6;
}
.detail {
  padding-bottom: 10rem;
}
.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem;
  border-radius: 0.75rem;
  .title {
    color: rgba(120, 132, 158, 1);
    font-size: 0.75rem;
    padding: 1rem 1.25rem;
  }
  .panel {
    /* display: flex; */
    /* padding: 0rem 1rem 1rem 1rem; */
    margin: 0 1rem;
    padding: 1rem;
    /* align-items: center; */
    img {
      width: 4.125rem;
      height: 4.125rem;
      border-radius: 50%;
      margin-right: 0.75rem;
      object-fit: cover;
    }
    .info {
      flex: 1;
      .name {
        color: #454f63;
        font-size: 1.5rem;
        font-weight: bold;
      }
      .phone {
        color: #cad1e2;
        font-size: 0.875rem;
        margin-top: 0.25rem;
      }
    }
    .or {
      margin: 0.5rem 0;
      color: #78849e;
    }
    .center {
      text-align: center;
    }
    .time {
      font-size: 1rem;
      color: #78849e;
    }
  }
}
.cell {
  padding: 0.5rem 0;
  color: #454f63;
  font-size: 0.875rem;

  .headline {
    display: inline-block;
    color: #78849e;
    font-size: 0.75rem;

    margin-right: 1rem;
    width: 4rem;
    text-align: right;
  }
}
.dialog-wrap {
  /* padding: 20px; */
  .wrap {
    padding: 10px;
    display: flex;
    flex-direction: column;
    .title {
      text-align: center;
      margin: 1rem 0;
      color: red;
    }
    .remak {
      outline: none;
      border: none;
      background: #f7f7fa;
      padding: 10px 15px;
      border-radius: 30px;
      margin: 10px 0 20px 0;
    }
  }
}
.btn-group {
  width: 100%;
  margin-top: 2.5rem;
  /* left: 0; */
  .btn-wrap {
    padding: 0 1rem 2rem;
  }
}
.person-list {
  margin: 1rem 1rem 0;
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #ffffff;
  border-radius: 0.75rem;
  .person-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    > span {
      color: rgba(120, 132, 158, 1);
      font-size: 0.75rem;
    }
    > div {
      .iconfont {
        font-size: 0.75rem;
      }
      font-size: 0.875rem;
      color: rgba(52, 151, 253, 1);
    }
  }
  .person-item {
    padding: 1rem 0;
    margin: 0 1rem;
    border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    margin-bottom: 0.6rem;
    &:last-child {
      border-bottom: none;
    }
    .person-name {
      color: rgba(69, 79, 99, 1);
      font-size: 1rem;
      font-weight: 400;
      margin-bottom: 0.125rem;
    }
    .person-phone {
      color: rgba(120, 132, 158, 1);
      font-size: 0.875rem;
    }
    .person-avatar {
      margin-right: 1rem;
      img {
        width: 3rem;
        height: 3rem;
        border-radius: 0.75rem;
        margin: 0 auto;
        display: block;
        object-fit: cover;
      }
    }
    .handle {
      background: rgba(233, 235, 239, 1);
      border-radius: 0.5rem;
      font-size: 0.6875rem;
      width: 5rem;
      height: 2rem;
      text-align: center;
      line-height: 2rem;
      color: rgba(120, 132, 158, 1);
    }
  }
}
</style>
